// Shared limits and tunables. Anything the Bible/Guide states as a number lives in one of: pricing.ts, constants.ts, pin.ts, time.ts.
export const API_VERSION = 'v1';
export const APP_MIN_VERSION = '1.0.0';

// auth (Guide §8)
export const ACCESS_TOKEN_TTL_SEC = 15 * 60;
export const REFRESH_TOKEN_TTL_DAYS = 30;
export const DEVICE_TRUST_DAYS = 180;
export const OTP_LENGTH = 6;
export const OTP_TTL_SEC = 5 * 60;
export const OTP_RESEND_COOLDOWN_SEC = 60;
export const OTP_MAX_ATTEMPTS = 5;
export const PIN_MAX_ATTEMPTS = 5;
export const PIN_LOCK_MINUTES = 15;
export const OFFLINE_SESSION_PBKDF2_MIN_ITER = 310_000;

// sync (Guide §10)
export const SYNC_MAX_OPS_PER_PUSH = 100;
export const SYNC_PULL_DEFAULT_LIMIT = 500;
export const SYNC_SNAPSHOT_LIMIT = 1000;
export const SYNC_RETRY_MAX_MS = 5 * 60_000;
export const SYNC_INTERVAL_MS = 30_000;
export const SYNC_DEBOUNCE_MS = 2_000;
export const LOCAL_HISTORY_MONTHS = 13;
export const CLOCK_OFFSET_SAMPLES = 5;

// business rules
export const VOID_RESTORE_DAYS = 30;
export const RECYCLE_BIN_DAYS = 30;
export const INVOICE_SMS_MAX_AGE_HOURS = 24; // Bible 5.4 — only if synced within 24h of the sale
export const INVOICE_SMS_DEFAULT_MIN_AMOUNT = 0;
export const DEFAULT_DUE_DAYS = 30;
export const SMS_DLR_ASSUME_DELIVERED_HOURS = 72;
export const OWNERSHIP_COOLDOWN_HOURS = 48;
export const SUPPORT_ACCESS_GRANT_HOURS = 24;
export const DATA_DELETE_COOLING_OFF_DAYS = 14;
export const JOB_BATCH_ACCOUNTS = 200;
export const FREE_STAFF_GRACE_HOURS = 48; // quarantine rule: Staff/Premium entries >48h after becoming free

export const MAX_SHOPS_HARD_CAP = 20;
export const SHOP_NAME_MAX_LEN = 60;
export const PRODUCT_NAME_MAX_LEN = 200;
